import { render, staticRenderFns } from "./sole_proprietorship_accordion.vue?vue&type=template&id=0c50de92&"
import script from "./sole_proprietorship_accordion.vue?vue&type=script&lang=js&"
export * from "./sole_proprietorship_accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports